var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 94,
    viewBox: "0 0 50 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1833 71.7614L72.8236 79.4387C76.676 81.607 80.7882 77.0354 78.2255 73.4333L67.3014 58.078C65.9247 56.1428 66.4556 53.4484 68.4635 52.1802L89.2049 39.0792C92.9017 36.7442 90.9225 31.0176 86.5729 31.4635L66.4519 33.5263C63.8263 33.7955 61.6231 31.5711 61.9173 28.9482L64.6091 4.95187C65.1213 0.386003 58.9231 -1.48947 56.818 2.59442L45.6996 24.1645C44.5098 26.4728 41.5127 27.1276 39.4686 25.5258L21.0752 11.1127C17.6168 8.40272 12.8758 12.2386 14.8042 16.1865L27.8559 42.9067C28.8002 44.8398 28.1057 47.174 26.2583 48.2766L2.33795 62.5534C-1.53929 64.8675 0.563924 70.8339 5.03524 70.205L31.8474 66.434C34.3087 66.0878 36.5177 67.974 36.5615 70.4592L36.9037 89.8762C36.9806 94.2389 42.8836 95.528 44.7721 91.5945L53.4228 73.5766C54.4578 71.4208 57.0993 70.5884 59.1833 71.7614Z",
    fill: "#1B3B5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRight);
export default __webpack_public_path__ + "static/media/starRight.301212ec2fcd446c5328ebb0962862b0.svg";
export { ForwardRef as ReactComponent };